import { environment } from '../../../environments/environment';

/**
 * Logger that logs only in development builds
 */
export class Logger {

  /**
   * If it's a production build return the console.log function
   * @returns {any} console.log function if it's not a production build
   */
  static get log() {
    if (!environment.production) {
      return console.log.bind(window.console);
    } else {
      return () => {};
    }
  }

  /**
   * If it's a production build return the console.error function
   * @returns {any} console.error function if it's not a production build
   */
  static get error() {
    if (!environment.production) {
      return console.error.bind(window.console);
    } else {
      return () => {};
    }
  }

  /**
   * If it's a production build return the console.warn function
   * @returns {any} console.warn function if it's not a production build
   */
  static get warn() {
    if (!environment.production) {
      return console.warn.bind(window.console);
    } else {
      return () => {};
    }
  }

  /**
   * If it's a production build display an alert
   * @param message Message that should be displayed
   */
  static alert(message?: any) {
    if (!environment.production) {
      alert(message);
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/logger.service.ts